package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.rippleEffect
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.ObjectKinds
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Furniture
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun RestaurantObject(
    selectedFurniture: Furniture?,
    objectInfo: ObjectKinds,
    onClick:()->Unit,
)
{
    Column(
        modifier = Modifier
            .width(Dimen.tableOptionWidth)
            .height(Dimen.tableOptionHeight)
            .rippleEffect {
                onClick()
            }
            .padding(bottom = Dimen.mediumPadding)
            .margin(
                right = Dimen.largePadding,
                bottom = Dimen.largePadding,
            )
            .border(
                width = Dimen.smallThickness,
                color = Theme.ActionFocused.rgb,
                style = LineStyle.Solid,
            )
            .backgroundColor(
                if (
                    selectedFurniture?.objectKind==objectInfo.value
                    && selectedFurniture.shape==objectInfo.shape?.value
                    && selectedFurniture.width==objectInfo.width
                    && selectedFurniture.height==objectInfo.height
                    ){
                    Theme.YellowAlpha20.rgb
                } else Theme.Transparent.rgb
            )
            .borderRadius(r= Dimen.semiLargeRadius),
        horizontalAlignment = Alignment.CenterHorizontally

    )
    {
        Column(
            modifier = Modifier
                .size(Dimen.restaurantParentIconSize),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally,
        )
        {
            SvgImage(
                img = objectInfo.img,
                width = objectInfo.widthShownForSelection?.px,
                height = objectInfo.heightShownForSelection?.px,
            )
        }


        Spacer()

        SpanText(
            text = objectInfo.title,
            modifier = Modifier
                .cursor(Cursor.Pointer)
                .fillMaxWidth()
                .textAlign(TextAlign.Center)
                .padding(leftRight = Dimen.normalPadding)
                .fontSize(FontSizes.semiMediumFontSize)
                .color(Theme.TextPrimary.rgb)
                .fontFamily(FontFamily.Jakarta)
                .overflow(Overflow.Hidden)
                .textOverflow(TextOverflow.Ellipsis)
                .whiteSpace(WhiteSpace.NoWrap)
                .maxWidth(100.percent)
        )
    }

}
